
/* THE NINETY — viewport-accurate headline width */
(()=>{'use strict';
const ready=()=>{
 const target=document.querySelector('.ninety-opening .superword');
 if(!target)return;
 const span=target.querySelector('span');
 const container=target.closest('.ninety-opening-word');
 if(!span||!container)return;
 const fit=()=>{
  target.style.setProperty('--n12-hero-size','15.4vw');
  const available=Math.max(1,container.clientWidth-2);
  const rendered=span.getBoundingClientRect().width;
  if(!Number.isFinite(rendered)||!rendered)return;
  const computed=parseFloat(getComputedStyle(target).fontSize);
  const factor=Math.min(1.12,available/rendered);
  const newSize=Math.max(20,computed*factor);
  target.style.setProperty('--n12-hero-size',newSize.toFixed(2)+'px');
 };
 requestAnimationFrame(fit);
 let id;
 addEventListener('resize',()=>{clearTimeout(id);id=setTimeout(fit,80)},{passive:true});
 document.fonts?.ready?.then(fit).catch(()=>{});
 document.addEventListener('ninety:route:load',()=>requestAnimationFrame(fit));
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
})();
